// Axios
import axios from "axios";

// Toast
import { toast } from 'react-toastify';

// Alert Dialog
import { confirmAlert } from 'react-confirm-alert'; // Import
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css

// Helpers
import Helpers from ".";

// Config
import Config from '../config';

// Stores
import OrderStore from '../mobx/stores/OrderStore';

const populates = "populate[0]=currency&populate[1]=products&populate[2]=products.main_image&populate[3]=products.product_unit&populate[4]=payment_type";

const getOrders = async () => {
    const ordersData = OrderStore.orders;

    if (OrderStore.loadingItemStatus) {
        return; // İşlem devam ediyorsa, tekrar çağırmayı engelle
    }

    if (ordersData.page > ordersData.pageCount) {
        return; // Sayfa sayısı pageCount'ten büyükse, tekrar çağırmayı engelle
    }

    OrderStore.setLoadingItemStatus(true);

    try {
        const response = await axios.get(`${Config.App.apiUrl}/${Helpers.getSettings().apiEndPoints.order}?filters[user]=${Helpers.getUserData().id}&pagination[page]=${ordersData.page}&pagination[pageSize]=25&sort=createdAt:desc&${populates}`,
            {
                headers: {
                    Authorization: `Bearer ${Helpers.getUserData().token}`,
                }
            }
        );

        response.data.data.forEach((order: any) => {
            if (OrderStore.orderDatas[order.id] === undefined) {
                OrderStore.addOrderData(order.id, {
                    id: order.id,
                    ...order.attributes
                })
            }

            if (OrderStore.orders.content[order.id] === undefined) {
                OrderStore.addOrder(order.id, {
                    id: order.id,
                    ...order.attributes
                })
            }
        });

        OrderStore.setPaginationData(ordersData.page + 1, response.data.meta.pagination.pageCount);
    } catch (error) {
        console.log('getOrders:', error);
    }

    OrderStore.setLoadingItemStatus(false);
};

const getOrder = async (id: number) => {
    OrderStore.setLoadingItemStatus(true);

    try {
        const response = await axios.get(`${Config.App.apiUrl}/${Helpers.getSettings().apiEndPoints.order}?filters[id][0]=${id}&filters[user][1]=${Helpers.getUserData().id}&${populates}`,
            {
                headers: {
                    Authorization: `Bearer ${Helpers.getUserData().token}`,
                }
            }
        );

        response.data.data.forEach((order: any) => {
            if (OrderStore.orderDatas[order.id] === undefined) {
                OrderStore.addOrderData(order.id, {
                    id: order.id,
                    ...order.attributes
                })
            }
        });
    } catch (error) {
        console.log('getOrder:', error);
    }

    OrderStore.setLoadingItemStatus(false);
};

const createOrder = async (values: any) => {
    try {
        const storeId = localStorage.getItem('storeId');

        const response = await axios.post(`${Config.App.apiUrl}/${Helpers.getSettings().apiEndPoints.order}`,
            {
                data: {
                    store_id: storeId,
                    ...values
                }
            },
            {
                headers: {
                    Authorization: `Bearer ${Helpers.getUserData().token}`,
                }
            }
        );

        if (response.data.status) {
            toast(Helpers.translation(response.data.message))
        } else {
            confirmAlert({
                title: Helpers.translation('error'),
                message: Helpers.translation(response.data.message),
                buttons: [
                    {
                        label: Helpers.translation('i-got-it'),
                    }
                ]
            });
        }

        return response.data;
    } catch (error) {
        console.log('createOrder:', error);
    }
}

const searchOrders = async (resetSearchRecord: boolean = false) => {
    const filters = OrderStore.searchFilterText;

    if (filters !== "") {
        if (resetSearchRecord) {
            OrderStore.resetSearchOrders();
        }

        const searchOrdersData = OrderStore.searchOrders;

        if (OrderStore.loadingItemStatus) {
            return; // İşlem devam ediyorsa, tekrar çağırmayı engelle
        }

        if (searchOrdersData.page > searchOrdersData.pageCount) {
            return; // Sayfa sayısı pageCount'ten büyükse, tekrar çağırmayı engelle
        }

        OrderStore.setLoadingItemStatus(true);

        try {
            const response = await axios.get(`${Config.App.apiUrl}/${Helpers.getSettings().apiEndPoints.order}?pagination[page]=${searchOrdersData.page}&pagination[pageSize]=25&sort=createdAt:desc${filters}&${populates}`,
                {
                    headers: {
                        Authorization: `Bearer ${Helpers.getUserData().token}`,
                    }
                }
            );

            response.data.data.forEach((order: any) => {
                if (OrderStore.orderDatas[order.id] === undefined) {
                    OrderStore.addOrderData(order.id, {
                        id: order.id,
                        ...order.attributes
                    })
                }

                if (OrderStore.searchOrders.content[order.id] === undefined) {
                    OrderStore.addSearchOrder(order.id, {
                        id: order.id,
                        ...order.attributes
                    })
                }
            });

            OrderStore.setSearchPaginationData(searchOrdersData.page + 1, response.data.meta.pagination.pageCount);
        } catch (error) {
            console.log('searchOrders:', error);
        }

        OrderStore.setLoadingItemStatus(false);
    }
};

const exportHelpers = {
    getOrders,
    getOrder,
    searchOrders,
    createOrder,
}

export default exportHelpers;